import angular from 'angular';
import {AddAccountBusinessChatController} from './addAccountBusinessChat.controller.js';
import {AddAccountBusinessChatLandingPageController} from './addAccountBusinessChatLandingPage.controller';
import {AddAccountBusinessChatConfirmationController} from './addAccountBusinessChatConfirmation.controller';

angular.module('parameters.addAccountBusinessChat', [])
  .controller('AddAccountBusinessChatController', AddAccountBusinessChatController)
  .controller('AddAccountBusinessChatLandingPageController', AddAccountBusinessChatLandingPageController)
  .controller('AddAccountBusinessChatConfirmationController', AddAccountBusinessChatConfirmationController)
;
